import { defaultReportsFilterFields } from '@/features/reports/constants/defaultReportsFilterFields.constant';

export const reportFilters = {
  default: defaultReportsFilterFields.textField,
  created_at_gteq: defaultReportsFilterFields.dateField,
  created_at_lteq: defaultReportsFilterFields.dateField,
  city_id_eq: defaultReportsFilterFields.citySelectField,
  product_id_eq: defaultReportsFilterFields.productSelectField,
};
